<div class="documents-panel">
  <div class="panel-header">
    <h3 class="panel-title">Belege &amp; Dokumente</h3>
    @if (documents().length > 0) {
      <small class="panel-count">{{ countLabel() }}</small>
    }
  </div>

  @if (documentsResource.isLoading()) {
    <div class="loading">
      <ui-spinner></ui-spinner>
    </div>
  } @else if (documentsResource.error()) {
    <ui-alert class="full-width" theme="error" message="Beim Laden der Dokumente ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal."></ui-alert>
  } @else if (documents().length === 0) {
    <p class="no-documents">Für diese Bestellung sind noch keine Dokumente verfügbar. Rechnungen und Lieferscheine stehen nach der Rechnungsstellung bereit.</p>
  } @else {
    @if (downloadFailed()) {
      <ui-alert class="full-width" theme="error" message="Das Dokument konnte nicht heruntergeladen werden. Bitte versuchen Sie es noch einmal."></ui-alert>
    }

    <mat-list class="documents-list">
      @for (tile of documentTiles(); track tile.document.fileName) {
        <mat-list-item>
          <ui-icon [faName]="tile.icon" faStyle="light" matListItemIcon></ui-icon>
          <span matListItemTitle>{{ tile.document.fileName }}</span>
          <span matListItemLine>{{ tile.meta }}</span>
          <ui-icon-button
            (clicked)="onDownload(tile.document)"
            [loading]="downloadingFileNames().has(tile.document.fileName)"
            buttonStyle="unthemed"
            icon="download"
            iconStyle="light"
            matListItemMeta
            tooltip="Herunterladen"
            tooltipPosition="above"
          ></ui-icon-button>
        </mat-list-item>
      }
    </mat-list>
  }

  <div class="panel-footer">
    <ui-button (clicked)="onClose()" buttonStyle="text">Schließen</ui-button>
  </div>
</div>
